export const FILTER_RESET_VALUES: any = {
  appliedDate: [null, null],
  timezone: null,
  merchantId: null,
  providerIds: [],
};
